import React, { useEffect, useState } from "react";
import TopNav from "../layouts/TopNav";
import "../Styles/invoiceTable.css";
import { ToastContainer, toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

type Requisition = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: any;
  quantity: string;
  _id: string;
  loadingSlip: any;
  customer: any;
  firstName: string;
  staff: any;
  business: string;
  items: any;
  businessType: string;
};

const RequisitionTable = () => {
  const token = window.localStorage.getItem("token");
  const [getInvoice, setgetInvoice] = useState<Requisition[]>([]);
  const [reLogin, setReLogin] = useState(false);

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/requisition", {
        headers: headers,
      })
      .then((res) => {
        setgetInvoice(res.data.data);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="board">
      <ToastContainer />
      <TopNav title="Invoice" />
      {reLogin ? <ReLoginModal /> : null}

      <div className="invoiceTable">
        <table className="inTable">
          <tr className="heTable">
            <th>Business Name</th>
            <th>Description</th>
            <th>Item Name</th>
            <th>Unit Price</th>
            <th>Quantity to Load</th>
            <th>Total Cost</th>
            <th>Approve</th>
          </tr>

          {getInvoice
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((invoice, inx) => {
              const requisitions = invoice?.items;
              return (
                <>
                  {requisitions.map((req: any, reqIndex: number) => {
                    return (
                      <tr key={`${inx}-${reqIndex}`} className="taData">
                        <td>{invoice?.staff?.firstName}</td>
                        <td>{invoice?.customer?.businessName}</td>
                        <td>{invoice?.businessType}</td>
                        <td>{req.itemName}</td>
                        <td>{req?.unitPrice}</td>
                        <td>{req?.totalCost}</td>
                        <td></td>
                      </tr>
                    );
                  })}
                </>
              );
            })}
        </table>
      </div>

      <TablePagination
        rowsPerPageOptions={[15, 25, 50]}
        component="div"
        count={getInvoice.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default RequisitionTable;
